import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch.jsx';

const SbSharedRefineMenuFilterMaterialComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterMaterial = createFragmentContainer(
    SbSharedRefineMenuFilterMaterialComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterMaterial_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterMaterial_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_itemSearch
            }
        `,
    }
);
